<div>
  <ng-container>
    @if ((!showSelected)) {
      <div class="row mx-0 mb-1 border">
        <div class="col-md-1 group-code pe-1">
          {{group.code}}
        </div>
        <!-- Groups with no selected article -->
        <div class="col-md-11 px-0">
          <ul class="list-group list-group-flush">
            @if ((!showSelected && group.selectedArticle)) {
              <li class="list-group-item py-0 fw-bold ps-1 pe-0">{{ 'SELECTED' | translate}}
                <small class=" me-1 btn btn-sm btn-dark clickable withOpacity my-1"
                  (click)="removeCheckArticle(group.selectedArticle)">{{'RESET'
                | translate}}</small>
              </li>
            }
            @if ((!showSelected && !group.selectedArticle)) {
              @for (article of articles; track article; let itemIndex = $index) {
                <li class="list-group-item py-0 px-0">
                  <app-tree-view-item [showPrices]="true" [article]="article" [showArticleCode]="true" [index]="itemIndex" [imageSize]="48" [showCheckbox]="true" [showViewButton]="true"
                  (checkArticle)="selectArticle($event)"></app-tree-view-item>
                </li>
              }
            }
          </ul>
        </div>
      </div>
    }
  </ng-container>

  <!-- Groups with a selected article -->
  @if ((showSelected && group.selectedArticle) ) {
    <div class="row mx-0 mt-b border selected-articles">
      <div class="col-md-1 group-code pe-1">
        {{group.code}}
      </div>
      <div class="col-md-11 px-0">
        <ul class="list-group list-group-flush">
          <li class="list-group-item py-0 px-0">
            <div class="row mx-0">
              <div class="col-md-12 px-0">
                <app-tree-view-item [showPrices]="true" [showArticleCode]="true" [article]="group.selectedArticle" [index]="0" [showCheckbox]="true" [showQuantityInput]="showQuantityInput" [showViewButton]="true"
                (checkArticle)="removeCheckArticle($event, group.selectedArticle)"></app-tree-view-item>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  }
</div>
